import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { AppState } from 'src/app/store/app.states';
import { getAdminUserInfo } from 'src/app/store/selector/selector';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-admin-new-seriesvideo',
  templateUrl: './new-seriesvideo.component.html',
  styleUrls: ['./new-seriesvideo.component.scss']
})
export class NewSeriesvideoComponent implements OnInit,OnChanges {
  @ViewChild('fileUploader') fileUploader:ElementRef;
  @Input() video:any;
  @Input() modalid:any;
  @Output() newItemEvent = new EventEmitter<string>();
  submitting=false;
  user:any
  format:any;
  data = [{ skill: ''}]
  videourl:any="";
  imageurl:any="";
  videofile:any=null;
  imagefile:any=null;
  description="";
  name="";
  is_trailor=0;
  is_featured=0;
  signatureseries="";
  allsignatureseries=[];
  sort=0;
  Form: FormGroup = this.fb.group({
    name: [this.name, Validators.compose([Validators.required])],
    video: ["", Validators.compose([Validators.required])],
    thumbnail:[""],
    sort:[this.sort, Validators.compose([Validators.required,Validators.pattern('^[0-9]*$')])],
    signatureseries: [this.signatureseries, Validators.compose([Validators.required])],
    description: [this.description, Validators.compose([Validators.required])],
    is_featured:[0],
    is_trailor:[0],
  }); 
  activeCtrl: FormControl;
  editor:any;


  constructor(private fb: FormBuilder,private store: Store<AppState>, private toastrService: ToastrService, public adminApi: AdminapiService) {
  }
  
  onSelectFile(event) {
    const file = event.target.files && event.target.files[0];
    if (file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      if(file.type.indexOf('image')> -1){
        this.imagefile=file;
        this.format = 'image';
      } else if(file.type.indexOf('video')> -1){
        this.videofile=file;
        this.format = 'video';
      }
      reader.onload = (event) => {
        if(this.format=='video'){
          this.videourl = (<FileReader>event.target).result;
          this.getVideoCover(file)
        }else if(this.format=='image'){
          this.imageurl = (<FileReader>event.target).result;
        }
      }
    }
  }

  getVideoCover(file, seekTo = 3) {
    //console.log("getting video cover for file: ", file);
    return new Promise((resolve, reject) => {
        // load the file to a video player
        const videoPlayer = document.createElement('video');
        videoPlayer.setAttribute('src', URL.createObjectURL(file));
        videoPlayer.load();
        videoPlayer.addEventListener('error', (ex) => {
            reject(ex);
        });
        // load metadata of the video to get video duration and dimensions
        videoPlayer.addEventListener('loadedmetadata', () => {
            // seek to user defined timestamp (in seconds) if possible
            if (videoPlayer.duration < seekTo) {
                reject("video is too short.");
                return;
            }
            // delay seeking or else 'seeked' event won't fire on Safari
            setTimeout(() => {
              videoPlayer.currentTime = seekTo;
            }, 200);
            // extract video thumbnail once seeking is complete
            videoPlayer.addEventListener('seeked', () => {
                //console.log('video is now paused at %ss.', seekTo);
                // define a canvas to have the same dimension as the video
                const canvas = document.createElement("canvas");
                canvas.width = videoPlayer.videoWidth;
                canvas.height = videoPlayer.videoHeight;
                // draw the video frame to canvas
                const ctx = canvas.getContext("2d");
                ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
                // return the canvas image as a blob
                let dataURI = canvas.toDataURL('image/jpeg');
                // let a = 
                let boj={
                  canvas:canvas,
                  file:this.dataURLtoFile(dataURI, `${+new Date()}.jpg`),
                  base64:dataURI
                }

                // this.imagefile = boj.file
                // this.imageurl = boj.base64;
                return boj;
                // ctx.canvas.toBlob(
                //     blob => {
                //         resolve(blob);
                //     },
                //     "image/jpeg",
                //     0.75 /* quality */
                // );
            });
        });
    });
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime, lastModified:new Date().getTime() });
  }

  getThumbUrl(url : string){
    return  "assets/images/"+url
  }

  getVideoUrl(url : string){
    return  "assets/videos/"+url
  }

  updateCheckBoxVal(key, eve) {
    this.activeCtrl = this.Form.get(key) as FormControl;
    this.activeCtrl.patchValue(eve.checked);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.name="";
    this.signatureseries="";
    this.description="";
    this.videourl=null;
    this.imageurl=null;
    this.is_trailor=0;
    this.is_featured=0;
    this.sort=0;
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 100); 
    if(this.video){
      this.name=this.video.name;
      this.signatureseries=this.video.signature_series_id;
      this.description=this.video.description;
      this.videourl=this.getVideoUrl(this.video.videothumb);
      this.imageurl=this.getThumbUrl(this.video.thumbnail);
      this.is_trailor=this.video.is_trailor;
      this.is_featured=this.video.is_featured;
      this.sort=this.video.sort;
      //this.getLevelRules(this.level.id)
    }
    this.initForm()
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
      this.getVideoFormData()
    },100)
    $(document).ready(() => {   
        setTimeout( ()=> { 
           $('.selectpicker').selectpicker('refresh');
        }, 500); 
    });  
  } 

  getUserData(){
    this.store.pipe(select(getAdminUserInfo)).subscribe(data=>{
      this.user = data
    },error=>{
      this.toastrService.error("unable to handle response");
    })
  }
  
  getVideoFormData(){
    this.adminApi.setLoader(true)
    this.adminApi.getSeriesVideoFormData().subscribe((data: any) => {
      this.allsignatureseries = data.signatureseries
      setTimeout( ()=> { 
        $('.selectpicker').selectpicker('refresh');
      }, 600); 
      this.adminApi.setLoader(false)
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  handleEvent($event){
    if(!this.editor){
      this.editor=$event.editor
    }
  }

  initForm(){
    this.Form = this.fb.group({
      name: [this.name, Validators.compose([Validators.required])],
      video: ["", !this.video?Validators.compose([Validators.required]):null],
      thumbnail: [""],
      sort:[this.sort, Validators.compose([Validators.required,Validators.pattern('^[0-9]*$')])],
      signatureseries: [this.signatureseries, Validators.compose([Validators.required])],
      description: [this.description, Validators.compose([Validators.required])],
      is_featured:[this.is_featured],
      is_trailor:[this.is_trailor]
    });

    if(this.editor){
      this.editor.setContent(this.description);
    }
    
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 100); 
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.submitting) {
      this.submitting = true;
      if(this.video){
        form.value.id=this.video.id
      }else{
        form.value.id="";
      }
      const formData = new FormData();
      formData.append('id',form.value.id);
      formData.append('name', form.value.name);
      formData.append('sort', form.value.sort);
      formData.append('video', this.videofile);
      formData.append('thumbnail', this.imagefile);
      formData.append('is_featured', form.value.is_featured);
      formData.append('is_trailor', form.value.is_trailor);
      formData.append('signatureseries', form.value.signatureseries);
      formData.append('description', form.value.description);
      this.adminApi.addSeriesVideo(formData).subscribe((data: any) => {
        if (data.success) {
          this.addNewItem('change')
          this.videofile="";
          this.fileUploader.nativeElement.value = null;
          if(!this.video){
            form.reset();
            $('.selectpicker').selectpicker('refresh');
          }
					this.toastrService.success(data.message);
          $('#'+this.modalid).modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } else {
      form.markAllAsTouched();
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.Form.controls;
  }
  
}
